import React, { 
	useState, 
	useEffect 
} from "react";

import { 
	NavLink 
} from "react-router-dom";

import { 
	addDays, 
	format 
} from "date-fns";

import { 
	DateRangePicker 
} from "materialui-daterange-picker";

import {
	TextField,
	Grid,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";

import {
	isLoggedIn
} from "../../../../components/Cookies/Cookies";

import ReceiptIcon from '@material-ui/icons/Receipt';
import DynamicTable from "../../../../components/DynamicTable";

const JCPortalQuestRedeemedVouchers = () => {
	const x = 0;
	useEffect(() => {
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		onFetchedApi();
	}, []);

	const url = "get_quest_claimed_voucher_list";

	const refDataFilter = React.createRef();

	const [posts, setPosts] = useState(null);
	const [open, setOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});

	const onFetchedApi = () => {
		refDataFilter.current.onFetchApi();
	};

	const toggle = () => setOpen(!open);

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const columns = [
		{
			name: "date_redeemed",
			label: "Date Redeemed"
		},
		{
			name: "idno",
			label: "ID No."		
		},
		{
			name: 'full_name',
			label: "Full Name",
		},
		{
			name: "quest_title",
			label: "Quest Title",

		},
		{
			name: "questvouchercode",
			label: "Voucher Code"
		},
		{
			name: "admin_user",
			label: "Admin Processed"
		},
	];

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/reports">
						<h2 className="header-title">Reports</h2>
					</NavLink>
					<Typography color="textPrimary">JC Portal Quest Redeemed Vouchers</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
					<Grid container spacing={1}>
						<Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
							<TextField
								id="outlined-basic"
								label="Select Date"
								variant="outlined"
								onFocus={() => setOpen(true)}
								fullWidth={true}
								autoComplete="off"
								value={`${format(
									dateRange.startDate,
									"MM/dd/yyyy"
								)} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
							/>
							<DateRangePicker
								open={open}
								toggle={toggle}
								onChange={(range) => dateRangeHandler(range)}
							/> 
						</Grid>
						<Grid item xs={1} xl={1}>
							<Button style ={{marginTop: "22px"}} variant="contained" color="primary"  onClick={() => {onFetchedApi()}}>Search</Button>
						</Grid>
					</Grid>       
				</div>
				<DynamicTable
					title="JC Portal Quest Redeemed Vouchers"
					columns={columns}
					rows={posts}
					setRows={setPosts}
					ref={refDataFilter}
					dateRange = { dateRange }
					url={url}
          		/>
			</div>
		</div>
	);
};

export default JCPortalQuestRedeemedVouchers;
